export const checkRole = (expectRole: string | string[]) => {
  const currentRole = localStorage.getItem('role');

  if (!currentRole) return false;

  if (Array.isArray(expectRole)) {
    return expectRole.includes(currentRole);
  }

  return currentRole === expectRole;
};
